import React from 'react';
import { Helpers } from '../../core/src/helpers';

const MAX_DEPTH = 80;

class BvRating extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
			showBV: true,
			reviewClickHandler: false, 
        }
		this.handleClick = this.handleClick.bind(this);
		this.handleHover = this.handleHover.bind(this);
	}
	
	componentDidMount(){
		this.getReviewBtn(1);
		if (typeof window.bvCallback === 'undefined') {
			window.bvCallback = (BV) => {
				BV.reviews.on('show', () => {
					this.props.onRatingsClick();
				});
			}
		}
	}

    componentDidUpdate(prevProps){
        if(prevProps.sku !== this.props.sku){
            this.setState({showBV: false, reviewClickHandler: false}, ()=> {
				this.getReviewBtn();
			});
        }
        if(!this.state.showBV){
            this.setState({showBV: true})
        }
	}

    handleClick(e) {
        if(e.target.className !== 'bv_button_buttonMinimalist') {
			this.props.onRatingsClick();
        }
	}
		
	getReviewBtn( depth=1 ) {
		if (depth > MAX_DEPTH){
			return;
		}
		try{
			if( document.querySelector('.bv_button_buttonFull ')){
				this.reviewBtnList = document.getElementsByClassName('bv_button_buttonFull ');
				this.reviewBtn = this.reviewBtnList[this.reviewBtnList.length - 1];
				this.reviewBtn && this.reviewBtn.addEventListener('click', this.handleClick);
				return;
			}
			this.reviewRowList =  document.getElementsByClassName('reviews-row');
			this.reviewRow = this.reviewRowList[this.reviewRowList.length - 1]
			if (!this.reviewRow) {
				setTimeout(() => this.getReviewBtn(++depth), 500);
			} else {
				this.reviewRow.addEventListener("mouseover",this.handleHover);
			}
		}catch(e){
			
		}
	}
		
	handleHover() {
		if (this.state.reviewClickHandler === false) {
			setTimeout(()=>{
				this.reviewBtnList = document.getElementsByClassName('bv_button_buttonFull ');
				this.reviewBtn = this.reviewBtnList[this.reviewBtnList.length - 1];
				this.reviewBtn && this.reviewBtn.addEventListener('click', this.handleClick);
				this.setState({ reviewClickHandler: true })
			}, 200)
		}
	}

    render(){
        const transformedSKU = Helpers.BVTransformSKU(this.props.sku);
        return(
            this.state.showBV ? <div onClick={this.handleClick}>
                <div data-bv-show="rating_summary" data-bv-product-id={transformedSKU}>{this.props.placeHolder}</div>
            </div> : null
        )
    }
}

BvRating.defaultProps = {
    'sku': ""
};

export default BvRating;
